import { ReactNode, useCallback, useState } from 'react';
import { useFormSession } from '~/hooks';
import { FormDataType, FormKeys } from '~/types';
import { FormDataContext } from './FormDataContext';

const getValues = (getSession: (formKey: FormKeys) => FormDataType | undefined): FormDataType => {
    const customerDetails = getSession(FormKeys.CUSTOMER_DETAILS) ?? {};
    const targetIncome = getSession(FormKeys.TARGET_INCOME) ?? {};
    const statePension = getSession(FormKeys.STATE_PENSION) ?? {};
    const finalSalary = getSession(FormKeys.FINAL_SALARY) ?? {};
    const otherIncome = getSession(FormKeys.OTHER_INCOME) ?? {};
    const otherPensionPots = getSession(FormKeys.OTHER_PENSION_POTS) ?? {};
    const landingPosition = getSession(FormKeys.LANDING_POSITION) ?? {};
    const calculations = getSession(FormKeys.CALCULATIONS) ?? {};
    const exploreOptions = getSession(FormKeys.EXPLORE_OPTIONS) ?? {};
    const projectedPotValue = getSession(FormKeys.PROJECTED_POT_VALUE) ?? 0;
    const pots = getSession(FormKeys.POTS) ?? {};

    return {
        ...customerDetails,
        ...targetIncome,
        ...statePension,
        ...finalSalary,
        ...otherIncome,
        ...otherPensionPots,
        ...projectedPotValue,
        ...landingPosition,
        ...calculations,
        ...exploreOptions,
        ...pots,
    } as FormDataType;
};

export const FormDataProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const { getSession, setSession } = useFormSession();
    const [formData, setFormData] = useState<FormDataType>(getValues(getSession));

    const updateFormDataState = useCallback(
        (state: Partial<FormDataType>) => {
            setSession(state);
            setFormData(getValues(getSession));
        },
        [getSession, setSession]
    );

    return <FormDataContext.Provider value={{ ...formData, updateFormDataState }}>{children}</FormDataContext.Provider>;
};
